import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search, PartyPopper, ArrowRight } from "lucide-react";

const WaitlistPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(160_84%_45%/0.05),transparent_60%)]" />

      <div className="relative z-10 w-full max-w-md mx-auto px-6 text-center">
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <PartyPopper className="w-8 h-8 text-primary" />
        </div>

        <h1 className="text-3xl font-bold mb-3">You're on the List!</h1>
        <p className="text-muted-foreground mb-8">
          Thanks for trying Unranked. We'll notify you as soon as we launch with
          full access and subscription plans.
        </p>

        <Button variant="outline" onClick={() => navigate("/")} className="gap-2">
          <ArrowRight className="w-4 h-4 rotate-180" />
          Back to Home
        </Button>

        <div className="mt-12 flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <div className="w-6 h-6 rounded bg-primary flex items-center justify-center">
            <Search className="w-3 h-3 text-primary-foreground" />
          </div>
          <span className="font-medium text-foreground">Unranked</span>
        </div>
      </div>
    </div>
  );
};

export default WaitlistPage;
